module.exports = __webpack_public_path__ + "static/media/ambient_loop02_bi.eb23951f.mp3";